<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import "firebase/firestore";
import "firebase/storage";
import "firebase/messaging";
import "firebase/functions";
export default {
  data() {
    return {
      messaging: null,
    };
  },
  created() {
    if (firebase.messaging.isSupported()) {
      this.messaging = firebase.messaging();
      this.messaging.usePublicVapidKey(
        "BCcS5HvHkIr0kTK4HgDIUrP34oUf0rn9B1oFGW4oMmjuuv55acITGwYq0tdTgfRDw7GXO88eyrPustpzYSKxxAY"
      );
    }
    // Your web app's Firebase configuration
    // const firebaseConfig = {
    //   apiKey: "AIzaSyCs7WBgIEIIJt_NbnQQzWT3RMcwog__Wro",
    //   authDomain: "cie-saledb.firebaseapp.com",
    //   databaseURL: "https://cie-saledb.firebaseio.com",
    //   projectId: "cie-saledb",
    //   storageBucket: "cie-saledb.appspot.com",
    //   messagingSenderId: "272106797306",
    //   appId: "1:272106797306:web:550e1dc81347c3a7887143",
    //   measurementId: "G-MN1MY2DF2S"
    // };
    // // Initialize Firebase
    // firebase.initializeApp(firebaseConfig);
    //const messaging = firebase.messaging(); //Check if this is used anywhere?
  },
};
</script>
